module.exports = {
  namespaced: true,

  state: {
    /**
     * Whether modal is open or closed
     * @type {Boolean}
     */
    modalIsOpen: false,

    /**
     * Whether tab is open or closed
     * @type {Boolean}
     */
    tabIsOpen: false,

    /**
     * Data for share items
     * @type {Object}
     */
    data: {}
  },

  actions: {
    /**
     * Open share modal
     */
    openModal ({ commit }) {
      commit('SET_TAB_IS_OPEN', false)
      commit('SET_MODAL_IS_OPEN', true)
    },

    /**
     * Close share modal
     */
    closeModal ({ commit }) {
      commit('SET_MODAL_IS_OPEN', false)
    },

    /**
     * Open share tab
     */
    openTab ({ commit }) {
      commit('SET_MODAL_IS_OPEN', false)
      commit('SET_TAB_IS_OPEN', true)
    },

    /**
     * Close share tab
     */
    closeTab ({ commit }) {
      commit('SET_TAB_IS_OPEN', false)
    },

    setData ({ commit }, data) {
      commit('SET_DATA', data)
    }
  },

  mutations: {
    SET_MODAL_IS_OPEN (state, value) {
      state.modalIsOpen = value
    },

    SET_TAB_IS_OPEN (state, value) {
      state.tabIsOpen = value
    },

    SET_DATA (state, data) {
      state.data = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/share.js